import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Tax } from '@app/shared/models/tax';
import { TaxService } from '@app/shared/services/taxes/tax.service';
import { Observable } from 'rxjs';

@Component({
  standalone: false,
  selector: 'sbnb-add-tax-setup',
  templateUrl: './add-tax-setup.component.html',
  styleUrls: ['./add-tax-setup.component.scss'],
})
export class AddTaxSetupComponent implements OnInit {
  selectedRates: any[] = [];

  definedPercentageRates: any[] = [...this.taxService.definedPercentageRates];
  tax: Tax = null;
  @Input() tax$: Observable<Tax>;
  @Output() complete: EventEmitter<string> = new EventEmitter();

  constructor(private taxService: TaxService) { }

  ngOnInit(): void {
    this.tax$.subscribe((tax) => {
      this.tax = tax;
    });
  }

  onSelectRate(event: any, rate: any): void {
    if (event.checked) {
      this.tax.subjects = [...this.tax.subjects, rate.key];
    } else {
      const index = this.tax.subjects.findIndex((x) => x === rate.key);

      if (index !== -1) {
        this.tax.subjects.splice(index, 1);
      }
    }
  }

  progress() {
    this.complete.emit('duration');
  }

  back() {
    this.complete.emit('type');
  }
}
